import { render, staticRenderFns } from "./WorkpostPaintScreenPage.vue?vue&type=template&id=0cdf6384&scoped=true"
import script from "./WorkpostPaintScreenPage.vue?vue&type=script&lang=js"
export * from "./WorkpostPaintScreenPage.vue?vue&type=script&lang=js"
import style0 from "./WorkpostPaintScreenPage.vue?vue&type=style&index=0&id=0cdf6384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdf6384",
  null
  
)

export default component.exports